module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/socket-eu-cce8c53575aaaab56d15821d263ded00.svg";